import React from "react";
import { createElementClass } from "../helpers";
export var TableRow = function TableRow(_a) {
  var _b = _a.isHeader,
      isHeader = _b === void 0 ? false : _b,
      children = _a.children;
  return React.createElement("tr", {
    className: createElementClass("table-row" + (isHeader ? "-head" : ""))
  }, children);
};